"use client";
import { controlPressClassNames as e, getControlClassNames as t } from "../controls/control-class-names.js";
import { ControlHint as n } from "../controls/ControlHint.js";
import { ControlIcon as r } from "../controls/ControlIcon.js";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
import s from "clsx";
import { Button as c } from "@base-ui/react/button";
import { forwardRef as l, useId as u } from "react";
//#region src/components/icon-button/IconButton.tsx
var d = l(({ label: l, children: d, variant: f = "tertiary", size: p = "md", destructive: m, disabled: h = !1, disabledReason: g, tooltip: _ = !0, className: v, type: y = "button", "aria-describedby": b, focusableWhenDisabled: x, ...S }, C) => {
	let w = u(), T = h ? g : void 0;
	return /* @__PURE__ */ o(i, { children: [/* @__PURE__ */ a(n, {
		label: _ ? T ? `${l}: ${T}` : l : void 0,
		children: /* @__PURE__ */ a(c, {
			...S,
			type: y,
			ref: C,
			"aria-label": l,
			disabled: h,
			focusableWhenDisabled: x ?? !!T,
			"aria-describedby": [b, T ? w : void 0].filter(Boolean).join(" ") || void 0,
			"data-variant": f,
			"data-size": p,
			"data-destructive": m || void 0,
			"data-unavailable": h || void 0,
			className: s("pf-control pf-icon-button", t({
				variant: f,
				size: p,
				destructive: m,
				disabled: h,
				iconOnly: !0
			}), e, v),
			children: /* @__PURE__ */ a(r, {
				size: p === "lg" ? 20 : 16,
				children: d
			})
		})
	}), T && /* @__PURE__ */ a("span", {
		className: "pf-control-sr pf:sr-only",
		id: w,
		children: T
	})] });
});
d.displayName = "PathfinderIconButton";
//#endregion
export { d as IconButton };
